import _moment, {Moment} from 'moment';
const moment = _moment;

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT = 'yyyy-MM-DD';
export const MONTH_AND_YEAR_FORMAT = 'MMM yyyy';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm:ss A';
export const ISO_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';

// Common date formats to try when parsing
const COMMON_FORMATS = [
  'YYYY-MM-DD',
  'MM/DD/YYYY',
  'DD/MM/YYYY',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DD HH:mm:ss',
  'MM/DD/YYYY HH:mm:ss',
  'DD/MM/YYYY HH:mm:ss',
  'MMM DD YYYY',
  'MMMM DD YYYY',
  'MMM  DD YYYY', // Handle double spaces
  'MMMM  DD YYYY',
];

const format = (
  date: Date | string | undefined | Moment | null,
  formatting?: string
): any => {
  try {
    if (date) {
      let m: Moment;
      
      // If it's already a moment or Date object, use it directly
      if (date instanceof Date || (typeof date === 'object' && (date as any)._isAMomentObject)) {
        m = moment(date);
      } else if (typeof date === 'string') {
        // For strings, try to parse with a specific format to avoid fallback to JS Date()
        // First try to detect ISO format
        if (date.match(/^\d{4}-\d{2}-\d{2}/)) {
          m = moment(date, ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD'], true);
        } else if (date.match(/^\d{2}\/\d{2}\/\d{4}/)) {
          m = moment(date, 'MM/DD/YYYY', true);
        } else if (date.match(/^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}:\d{2}/)) {
          m = moment(date, 'MM/DD/YYYY HH:mm:ss', true);
        } else {
          // Try common formats
          m = moment(date, COMMON_FORMATS, true);
        }
        
        // If parsing failed, try native Date parsing
        if (!m.isValid()) {
          m = moment(new Date(date));
        }
      } else {
        m = moment(date);
      }

      // Check if moment object is valid before formatting
      if (!m.isValid()) {
        return '';
      }

      switch (formatting) {
        case DATE_TIME_FORMAT:
          return m.parseZone().format(DATE_TIME_FORMAT);
        case MONTH_AND_YEAR_FORMAT:
          return m.parseZone().format(MONTH_AND_YEAR_FORMAT);
        case DATE_FORMAT:
          return m.parseZone().format(DATE_FORMAT);
        default:
          return m.parseZone().format(DEFAULT_DATE_FORMAT);
      }
    }
  } catch (e) {
    console.error('Date formatting error:', e);
    return '';
  }
};

export default {
  format,
  DEFAULT_DATE_FORMAT,
  DATE_FORMAT,
  MONTH_AND_YEAR_FORMAT,
  DATE_TIME_FORMAT,
  ISO_FORMAT
};
